import React, { useEffect, useState } from "react";
import { NavList } from "../NavList";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { HeaderLogo, HeaderMobileLogo } from "../../customIcons";
import style from "./Navbar.module.css";

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 801px)");

  useEffect(() => {
    document.body.classList.toggle("no-scroll", isMenuOpen);

    return () => document.body.classList.remove("no-scroll");
  }, [isMenuOpen]);

  return (
    <header className={style.header} id="header">
      <div className="container">
        <div className={style.box}>
          <Link to="/" aria-label="Home">
            {isDesktop ? <HeaderLogo /> : <HeaderMobileLogo />}
          </Link>
          <NavList nav={isMenuOpen} setNav={setIsMenuOpen} />
          <button
            type="button"
            aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
            aria-expanded={isMenuOpen}
            aria-controls="primary-navigation"
            onClick={() => setIsMenuOpen((current) => !current)}
            className={style.mobile_btn}
          >
            {isMenuOpen ? (
              <AiOutlineClose size={25} />
            ) : (
              <AiOutlineMenu size={25} />
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
